import initSentry from '@maxpreps/shared/functions/nextjs/sentry.client.config';

initSentry();
